<div class="text-muted mb-3" *ngIf="carregando">Carregando produção...</div>
<div class="alert alert-danger" *ngIf="erro">{{erro}}</div>
<div class="border rounded p-3 mb-3" *ngFor="let p of itens">
  <strong class="d-block mb-2">{{p.quantidade}} × {{p.itemPedido.descricao}}</strong>
  <ng-container *ngIf="statusDestino === 1">
    <fieldset class="atendimento mb-3" [disabled]="salvando">
      <legend>Atendimento</legend>
      <div class="atendimento-opcoes">
        <label class="atendimento-opcao" [class.selecionada]="p.atendimento === 'produzir'">
          <input type="radio" [name]="'atendimento-status-' + p.id" value="produzir" [(ngModel)]="p.atendimento"
                 (ngModelChange)="ajusteFichaAoMudarAtendimento(p)" [ngModelOptions]="{standalone: true}">
          <i class="fas fa-utensils" aria-hidden="true"></i>
          <strong>Produzir agora</strong>
        </label>
        <label class="atendimento-opcao" [class.selecionada]="p.atendimento === 'vitrine'">
          <input type="radio" [name]="'atendimento-status-' + p.id" value="vitrine" [(ngModel)]="p.atendimento"
                 (ngModelChange)="ajusteFichaAoMudarAtendimento(p)" [ngModelOptions]="{standalone: true}">
          <i class="fas fa-store" aria-hidden="true"></i>
          <strong>Usar pronto/vitrine</strong>
        </label>
      </div>
      <small class="d-block text-muted mt-1" *ngIf="p.atendimento === 'vitrine'">
        <ng-container *ngIf="p.semBaixaEstoque">Produto já produzido. Sem escolha de ficha, envio ao confeiteiro/KDS ou baixa de estoque.</ng-container>
        <ng-container *ngIf="!p.semBaixaEstoque">Usa o estoque do produto pronto, sem enviar ao confeiteiro/KDS. A saída do estoque será confirmada ao marcar o pedido como Pronto.</ng-container>
      </small>
    </fieldset>
    <label class="d-block" *ngIf="moduloComissionamentoAtivo && p.atendimento === 'produzir'">{{labelComissionado}}
      <select class="form-control" [(ngModel)]="p.comissionadoId" [ngModelOptions]="{standalone: true}" [disabled]="salvando">
        <option [ngValue]="null">Selecione</option>
        <option *ngFor="let c of comissionados" [ngValue]="c.id">{{c.nome}}</option>
      </select>
    </label>
  </ng-container>
  <div class="text-muted" *ngIf="statusDestino === 2 && p.semBaixaEstoque">Produto já produzido. Sem escolha de ficha, envio ao confeiteiro/KDS ou baixa de estoque.</div>
  <label class="d-block" *ngIf="statusDestino === 2 && !p.semBaixaEstoque">Ficha / receita
    <div class="form-control bg-light" *ngIf="p.fichas.length === 1">{{p.fichas[0].nome}}</div>
    <select class="form-control" *ngIf="p.fichas.length !== 1" [(ngModel)]="p.fichaId" [ngModelOptions]="{standalone: true}" [disabled]="salvando">
      <option [ngValue]="null">Selecione</option>
      <option *ngFor="let f of p.fichas" [ngValue]="f.id">{{f.nome}}</option>
    </select>
    <small class="text-muted">Ao confirmar, o estoque será baixado pela ficha selecionada.</small>
  </label>
</div>
